module.exports = __webpack_public_path__ + "img/002企业微信截图.80711649.png";